import { trackGa4Event } from 'utility/Track/trackingHelper';

import { notSet } from 'types/tracking';

import {
    Category,
    Category as CategoryTypes,
    HolidayHomeInformation,
} from 'proto/Hotel/HotelMedia';

import { GalleryType } from '../types';

const typeMap: Partial<Record<GalleryType, string>> = {
    [GalleryType.Images]: 'Hotelbilder',
    [GalleryType.GuestImages]: 'Gästefotos',
    [GalleryType.Videos]: 'Hotelvideos',
};
const categoryMap: Record<Category, string> = {
    [Category.All]: 'alle Bilder',
    [Category.Pool]: 'Pool',
    [Category.OutsideView]: 'Außenansicht',
    [Category.InsideView]: 'Innenansicht',
    [Category.Room]: 'Zimmer',
    [Category.FreeTime]: 'Freizeit',
    [Category.Location]: 'Umgebung',
    [Category.Others]: 'Sonstiges',
};

export const useTracking = () => {
    const trackOpen = (
        hotelId: number,
        hotelName: string,
        hasImg: boolean,
        hasGuestImg: boolean,
        hasVideos: boolean
    ) => {
        trackGa4Event('fotoVideoLayer_click_open', {
            hotel_id: hotelId ?? notSet,
            hotel_name: hotelName ?? notSet,
            fotovideo_categories: [
                hasImg ? typeMap[GalleryType.Images] : notSet,
                hasGuestImg ? typeMap[GalleryType.GuestImages] : notSet,
                hasVideos ? typeMap[GalleryType.Videos] : notSet,
            ].join(', '),
        });
    };

    const trackSelectType = (
        hotelId: number,
        hotelName: string,
        type: GalleryType
    ) => {
        trackGa4Event('fotoVideoLayer_category_click', {
            hotel_id: hotelId,
            hotel_name: hotelName ?? notSet,
            linktext: typeMap[type],
        });
    };

    const trackSelectCategory = (
        hotelId: number,
        hotelName: string,
        category: CategoryTypes | number,
        holidayHomeInformation?: HolidayHomeInformation
    ) => {
        trackGa4Event('fotoVideoLayer_filter_click', {
            hotel_id: hotelId,
            hotel_name: hotelName ?? notSet,
            linktext:
                typeof category === 'number'
                    ? holidayHomeInformation?.unitNameMap[category]
                    : categoryMap[category],
        });
    };

    return { trackOpen, trackSelectType, trackSelectCategory };
};
